import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { requestActiveUsers, analyticsSelector } from "../../api"

export const useActiveUsers = (days: number) => {
  const activeUsers = useSelector(analyticsSelector.activeUsers)(days)
  const dispatch = useDispatch()
  const [daysLoaded, setDaysLoaded] = useState(0)
  const [loading, setLoading] = useState(false)
  if (days && daysLoaded !== days && !loading) {
    const fetchData = async () => {
      setLoading(true)
      await dispatch(requestActiveUsers(days))
      setLoading(false)
      setDaysLoaded(days)
    }
    fetchData()
  }
  return {
    loading,
    activeUsers,
  }
}
